export enum TransportMode {
  Air = 'Air',
  Sea = 'Sea',
  Truck = 'Truck',
  Rail = 'Rail',
}
